import { render, staticRenderFns } from "./privilegegroup-dialog.vue?vue&type=template&id=5d7724f9&scoped=true"
import script from "./privilegegroup-dialog.vue?vue&type=script&lang=js"
export * from "./privilegegroup-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7724f9",
  null
  
)

export default component.exports